module.exports = __webpack_public_path__ + "static/slider1-b079854c28ee3fcce3b595bdb731b69c.jpg";